export default __webpack_public_path__ + "static/media/0073.42a4afc2.png";